import ActionTypes from "../Actions/ActionTypes"

const initialState = { 
    schedule: [],
    salesHistory: null
}

const ScheduleReducer = (state =  initialState, action) => {
     switch(action.type){
        case ActionTypes.GET_SCHEDULE:
            state = {...state, schedule: action.payload}
        break;
        case ActionTypes.SALES_HISTORY:
            
            state = {...state, salesHistory: action.payload}
        break;
         default:
      break;
     }
     return state   
}
export default ScheduleReducer;